





























import { Component, Vue } from 'vue-property-decorator'

import Server from '@tridoc/frontend'

@Component({
  components: {
  }
})
export default class ShareTarget extends Vue {
  uploaded = false;
  tmpDoc = '/ipfs/' + this.$route.query.file
  docPath: string | undefined;
  async mounted () {
    if (!this.$store.getters.server?.server) {
      throw new Error('No store configured!')
    }
    const cs = this.$store.getters.server?.server as Server
    const fetchResponse = await fetch(this.tmpDoc)
    const blob = await fetchResponse.blob()
    const uploadResult = await cs.uploadFile(blob as File)
    // TODO less horrible type handling
    if ((uploadResult as { location: string }).location) {
      this.uploaded = true
      this.docPath = (uploadResult as { location: string }).location
      await fetch(this.tmpDoc, { method: 'DELETE' })
      this.$router.replace({ path: this.docPath })
    } else {
      throw uploadResult
    }
  }
}

